<template>
  <section class="flex flex-col items-center !p-6" :class="grayBgStyle" v-if="!User.signedIn()">
    <Heading level="h3" class="text-center !pt-4"> <span v-html="I18n.t('pricing.free.subtitle_html')"></span></Heading>
    <div class="payg-section w-full rounded-4xl bg-white p-8 my-4" :class="outline">
      <h3 class="text-2xl !pb-2 font-body">{{ I18n.t("pricing.free.plan_feature_title") }}</h3>
      <p class="text-typo-secondary">{{ I18n.t("pricing.free.plan_feature_description") }}</p>
      <p class="text-typo-secondary">
        <span>
          {{ I18n.t("templates.already_have_an_account") }}
          <a :href="loginUrl">{{ I18n.t("navigation.login") }}</a>
        </span>
      </p>

      <Button variant="secondary" as="link" :href="signupUrl" :aria-label="I18n.t('pricing.free.action')">
        {{ I18n.t("pricing.free.action") }}
      </Button>
    </div>
  </section>
  <div v-if="!isExperimentEnabled" class="gray-bg-separator gray-bg w-full bg-seperator-end bg-repeat-x"></div>
</template>

<script setup lang="ts">
import { computed, inject } from "vue";
import { Heading, Button } from "prism";
import User from "@/modules/user";
import Flipper from "@/modules/flipper";

const I18n = inject("I18n");

const isExperimentEnabled = computed(() => Flipper.isEnabled("pricing_page_new_layout_experiment"));

const grayBgStyle = computed(() => ({
  "gray-bg": !isExperimentEnabled.value,
}));

const outline = computed(() => ({
  border: isExperimentEnabled.value,
}));

defineProps({
  loginUrl: String,
  signupUrl: String,
});
</script>

<style scoped lang="scss">
.payg-section {
  max-width: 48rem;
}

.gray-bg {
  background-color: #f1f3f4;
}

.gray-bg-separator {
  height: 1.5rem;
}
</style>
